import { ISnackbarMessage } from '../../types/snackbar';

export const ADD_SNACKBAR_MESSAGE = 'ADD_SNACKBAR_MESSAGE';

export const REMOVE_SNACKBAR_MESSAGE = 'REMOVE_SNACKBAR_MESSAGE';

export const addSnackbarMessage = (payload: ISnackbarMessage) => ({
  type: ADD_SNACKBAR_MESSAGE,
  payload,
});

export const removeSnackbarMessage = () => ({
  type: REMOVE_SNACKBAR_MESSAGE,
});
